import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EMPTY_FINANCIAL_KPI_DATA, FinancialKpiData, FinancialKpiSection } from "models/financial-kpi";
import FiscalCalendar from "utils/fiscal-calendar";

export interface FinancialKpiSliceState {
    fiscalYear: number;
    data: FinancialKpiData;
}

export const initialState: FinancialKpiSliceState = {
    fiscalYear: FiscalCalendar.currentFiscalYear(),
    data: EMPTY_FINANCIAL_KPI_DATA,
};

const FinancialKpiSlice = createSlice({
    name: "financial-kpi-slice",
    initialState,
    reducers: {
        // Changing the year clears the containers so stale numbers never show under the new year.
        setFinancialKpiFiscalYear(state, { payload }: PayloadAction<number>) {
            state.fiscalYear = payload;
            state.data = EMPTY_FINANCIAL_KPI_DATA;
        },
        setFinancialKpiSection(state, { payload }: PayloadAction<{ section: FinancialKpiSection, data: any }>) {
            (state.data as any)[payload.section] = payload.data;
        },
    },
});

export const { setFinancialKpiFiscalYear, setFinancialKpiSection } = FinancialKpiSlice.actions;

export default FinancialKpiSlice.reducer;
